import chartUtils from '../../../utils/chart-utils';

var buildPieTooltip = function buildPieTooltip(seriesConfig, data) {
    var TipField = seriesConfig.TipField,
        ShowPercentage = seriesConfig.ShowPercentage,
        FieldName = seriesConfig.FieldName;

    //take the value at the FieldName instead of just the options.y for negative value support

    var value = data.options[FieldName];

    var name = seriesConfig.ValueField ? seriesConfig.ValueField : seriesConfig.SeriesName;
    var tip = data.options[TipField] == null ? name : data.options[TipField] + '<br/>' + data.options.name;

    var defaultTipText = seriesConfig.ShowDefaultTooltip ? '<span>' + tip + ':</span><span> ' + chartUtils.format(value, seriesConfig.ValueFormat, seriesConfig.CurrencySymbol, null, seriesConfig.BaseFormat) + '</span>' : '';

    if (ShowPercentage) {
        var percentageDisplayFormat = seriesConfig.ValueFormat != "" ? seriesConfig.ValueFormat + "%" : ".0f%";
        defaultTipText += '<br /><span class="tip-header">' + seriesConfig.ValueField + ' %: </span><span class="tip-value">' + chartUtils.format(value / data.total * 100, percentageDisplayFormat, null, null, null) + '</span>';
    }

    return defaultTipText;
};

export default buildPieTooltip;